module.exports = __webpack_public_path__ + "static/mr-concert-performance-24-e2b61634f48d6b4e009f84c3d1f15727.jpg";